import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Creators as Actions } from "store/ducks/quotesDashboard";
//components
import QuoteStatusFilter from 'pages/Quotes/components/QuoteStatusFilter/QuoteStatusFilter';
import { VisibilityConditional } from 'components/VisibilityConditional';
import RadioButtons from 'pages/Quotes/components/RadioButtons';
import { Column, Row } from 'components/Layout/Grid';
import { Visibility } from 'components/Visibility';
import { Button } from 'components/Button';
import Text from 'components/Text';
//interfaces
import { HeaderGridProps } from './interface';
//styles
import { SearchInput, ContainerSearch, SearchButton, ColumnVerticalLine, CustomIcon } from './styles';
//assets
import IndicatorFilterIcon from "img/icon-reset-filter.svg";

const HeaderGrid: React.FC<HeaderGridProps> = (props) => {
  const {
    filterText,
    getPreOrder,
    statusViveo,
    orderStatus,
    resetFilters,
    setFilterText,
    statusBionexo,
    quoteCategory,
    selectedRadio,
    setCurrentPage,
    setStatusViveo,
    setOrderStatus,
    getBionexoQuote,
    setQuoteCategory,
    setSelectedRadio,
    setStatusBionexo,
    orderRadioSelected,
    dashboardQuoteFilter,
    setOrderRadioSelected,
    resetCardSelection,
    setNoRefresh
  } = props;

  const [length, setLength] = useState<number>(0);
  const [selectedGridOption, setSelectedGridOption] = useState<0 | 1 | 2>(0);

  const allQuotesDashboard = JSON.parse(process.env.REACT_APP_ALL_QUOTES_DASHBOARD!);
  const ruleColorDropdownStatus = statusBionexo.length > 3 || statusViveo.length > 3;
  const categoryDropdownRule = quoteCategory.length > 4;

  const dispatch = useDispatch();

  const clickEnterButton = (event: string) => {
    if (event === "Enter") {
      const trimmedFilterText = filterText.trim();
      setNoRefresh(true);

      if (trimmedFilterText === "") {
        if (!orderRadioSelected) {
          getBionexoQuote("", statusBionexo, statusViveo, quoteCategory, true);
        } else {
          getPreOrder("", orderStatus, quoteCategory, true, selectedGridOption);
        }
      } else {
        if (!orderRadioSelected) {
          getBionexoQuote(
            trimmedFilterText,
            statusBionexo,
            statusViveo,
            quoteCategory,
            true
          );
        } else {
          getPreOrder(
            trimmedFilterText,
            orderStatus,
            quoteCategory,
            true,
            selectedGridOption
          );
        }
      }
    }
  };

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFilterText(e.target.value);
  };

  const handleShowTipContent = () => {
    if (ruleColorDropdownStatus) {
      return 'É permitido selecionar apenas 3 opções de cada status';
    }

    if (categoryDropdownRule) {
      return 'É permitido selecionar apenas 4 opções de categoria';
    }

    return '';
  };

  const searchButtonOnClick = () => {
    if (orderRadioSelected) {
      setNoRefresh(true);
      getPreOrder(filterText, orderStatus, quoteCategory, true, selectedGridOption);

      dispatch({
        type: "SET_STATUS_BIONEXO",
        statusBionexo: []
      });
      dispatch({
        type: "SET_STATUS_VIVEO",
        statusViveo: []
      });
      dispatch({
        type: "SET_QUOTE_CATEGORIES",
        quoteCategory: quoteCategory
      });
    } else {
      setNoRefresh(true);
      dispatch({
        type: "SET_STATUS_BIONEXO",
        statusBionexo: statusBionexo
      });
      dispatch({
        type: "SET_STATUS_VIVEO",
        statusViveo: statusViveo
      });
      dispatch({
        type: "SET_QUOTE_CATEGORIES",
        quoteCategory: quoteCategory
      });

      getBionexoQuote(filterText, statusBionexo, statusViveo, quoteCategory, true);
    }
  };

  const renderOrderInputText = () => {
    return (
      <Text className="StatusFilterLabel" size={12}>
        Buscar ID, razão social, cód. do cliente
      </Text>
    );
  };

  const renderQuoteInputText = () => {
    return (
      <Text className="StatusFilterLabel" size={12}>
        Buscar ID, razão social, cód. do cliente, descrição do produto
      </Text>
    );
  };

  useEffect(() => {
    if (resetCardSelection !== 0) {
      dispatch(Actions.setSelectedFilterCard(null));
    }
  }, [resetCardSelection, dispatch]);  

  return (
    <Row className="w-100 align-center justify-between">
      <ContainerSearch className="w-sm-100 mt-3 mt-sm-1 mb-4 mb-sm-2 w-100">
        <Row className={`${allQuotesDashboard ? '' : 'w-10'}`}>
          <RadioButtons
            getPreOrder={getPreOrder}
            selectedRadio={selectedRadio}
            setStatusViveo={setStatusViveo}
            setOrderStatus={setOrderStatus}
            getBionexoQuote={getBionexoQuote}
            setStatusBionexo={setStatusBionexo}
            setSelectedRadio={setSelectedRadio}
            setOrderRadioSelected={setOrderRadioSelected}
          />

          <Visibility visible={allQuotesDashboard}>
            <QuoteStatusFilter
              length={length}
              setLength={setLength}
              notReloadStatus={true}
              filterText={filterText}
              setFilterText={setFilterText}
              setStatusViveo={setStatusViveo}
              setOrderStatus={setOrderStatus}
              setCurrentPage={setCurrentPage}
              selectedViveoStatus={statusViveo}
              selectedOrderStatus={orderStatus}
              setStatusBionexo={setStatusBionexo}
              setQuoteCategory={setQuoteCategory}
              selectedBionexoStatus={statusBionexo}
              selectedQuoteCategory={quoteCategory}
              orderRadioSelected={orderRadioSelected}
              dashboardQuoteFilter={dashboardQuoteFilter}
              setSelectedGridOption={setSelectedGridOption}
              selectedGridOption={selectedGridOption}
            />
          </Visibility>

          <SearchButton
            id="search-button"
            onClick={() => searchButtonOnClick()}
            disabled={ruleColorDropdownStatus || categoryDropdownRule}
          >
            <Text
              className="font-bold"
              showTip={ruleColorDropdownStatus || categoryDropdownRule}
              showTipContent={handleShowTipContent()}
              color="#ffffff"
            >
              Filtrar
            </Text>
          </SearchButton>

          <Button 
            width={143}
            id="button-reset-filter"
            className="outline bg-primary flex-sm-1 align-center justify-center d-flex"
            onClick={() => {
              if(resetFilters) {
                resetFilters();
              }
            }}
          >
            <CustomIcon src={IndicatorFilterIcon} alt="Icon" />
            <Text className="color-primary font-bold">Resetar filtros</Text>
          </Button>
        </Row>

        <Row className="w-100">
          <ColumnVerticalLine />
          <Column className="w-100">
            <VisibilityConditional
              condition={orderRadioSelected}
              firstOption={() => renderOrderInputText()}
              secondOption={() => renderQuoteInputText()}
            />

            <SearchInput
              onKeyPress={(e) => clickEnterButton(e.key)}
              onChange={handleSearchChange}
              value={filterText}
              type="text"
            />
          </Column>
        </Row>
      </ContainerSearch>
    </Row>
  );
};

export default HeaderGrid;